export default __webpack_public_path__ + "static/media/OlentzeroEitb.82180ee8.mp3";